import Router from './Router';
import './Router.scss';

export default Router;
